// Mobile OTP API login start
document.addEventListener('DOMContentLoaded', function () {
var getOtpBtnn = document.getElementById('sign_in_get_otp');
var mendatoryFieldMsg = document.querySelector('.sign_in_mendatory_field');
var mobileNumberInput = document.getElementById('sign_in_customer_mobile_number');
var customerOtp = document.getElementById('sign_in_customer_otp');
var customerResendOtpMsg = document.querySelector('.customer_resend_otp');
var resendOtpLinkk = document.getElementById('resend_otp');
var verifyOtpBtn = document.getElementById('login_verify_otp');

let resendTimer; 
if (getOtpBtnn) {
getOtpBtnn.addEventListener('click', function () {
  console.log("OTP in progress");
  sendOtp();
});
}
  if (resendOtpLinkk) {
resendOtpLinkk.addEventListener('click', function (event) {
  event.preventDefault(); // Prevent default link behavior
  if (!resendOtpLinkk.classList.contains('disabled')) {
    sendOtp();
    startResendTimer(); 
  }
});
  }

function sendOtp() {
  var mobileNumber = mobileNumberInput.value.trim();
 console.log("OTP sent");
  if (!mobileNumber) {
    mendatoryFieldMsg.textContent = "Mobile number is required.";
    mendatoryFieldMsg.style.display = "block";
    return;
  } else if (mobileNumber.length < 10) {
    mendatoryFieldMsg.innerText = 'Number is invalid';
    mendatoryFieldMsg.style.display = 'block';
    setTimeout(() => {
      mendatoryFieldMsg.style.display = 'none';
    }, 1000);
    return;
  } else {
    mendatoryFieldMsg.style.display = "none";
  }

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    "mobileNumber": mobileNumber
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch("https://dermalogica-otp-9112e155e180.herokuapp.com/otplogin/lakmesalonshop/login/sendotp", requestOptions)
    .then(response => response.json())
    .then(result => {
      console.log("API Response:", result);

      if (result.success) {
        mendatoryFieldMsg.textContent = result.message;
        mendatoryFieldMsg.style.display = 'block';
        mendatoryFieldMsg.style.color = 'green';
        customerOtp.style.display = 'block';
        getOtpBtnn.style.display = 'none';
        verifyOtpBtn.style.display = 'block';
        customerResendOtpMsg.style.display = 'block';
        startResendTimer();
        setTimeout(() => {
          mendatoryFieldMsg.style.display = 'none';
        }, 3000);
      } else {
        mendatoryFieldMsg.textContent = result.customers;
        mendatoryFieldMsg.style.display = "block";
        setTimeout(() => {
          mendatoryFieldMsg.style.display = "none";
        }, 3000);
      }
    })
    .catch(error => {
      console.error('Error:', error);
      mendatoryFieldMsg.textContent = "An error occurred while sending OTP.";
      mendatoryFieldMsg.style.display = "block";
    });
}

function startResendTimer() {
  let timeLeft = 300;
  resendOtpLinkk.classList.add('disabled');
  resendOtpLinkk.textContent = `Resend OTP in 5:00`;

  clearInterval(resendTimer);
  resendTimer = setInterval(() => {
    timeLeft--;
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    resendOtpLinkk.textContent = `Resend OTP in ${minutes}:${seconds.toString().padStart(2, '0')}`;

    if (timeLeft <= 0) {
      clearInterval(resendTimer);
      resendOtpLinkk.classList.remove('disabled');
      resendOtpLinkk.textContent = "Resend OTP";
    }
  }, 1000);
}
  // verify OTP login start
  if(verifyOtpBtn) {
verifyOtpBtn.addEventListener('click', function (event) {
  var mobileNumberverify = mobileNumberInput.value.trim();
  var customerOtpVerify = document.getElementById('sign_in_customer_otp').value.trim();
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  
  var raw = JSON.stringify({
    "mobileNumber": mobileNumberverify,
    "otp": customerOtpVerify
  });
  
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  
  fetch("https://dermalogica-otp-9112e155e180.herokuapp.com/otplogin/lakmesalonshop/login/verifyotp", requestOptions)
    .then(response => response.json())
    .then(result => {
      console.log("Verify OTP", result);
      if (result.success === true) {
        window.location.href = result.url
      } else {
        mendatoryFieldMsg.textContent = result.message;
        mendatoryFieldMsg.style.display = "block";
        mendatoryFieldMsg.style.color = 'red'
      }
    })
    .catch(error => { 
      console.log('error', error);
    });
});
  }

 // Register customer start
var signgetOtpBtntn = document.querySelector('#sign_get_otp');
 // console.log("jg>>>>>>>", signgetOtpBtntn);
var email_id = document.querySelector('#RegisterForm-email');
var mobileNumber = document.querySelector('#customer_sign_up_mobile_number');
var message = document.querySelector('.sign_up_mendatory_fieldd');
var enterSignOtp = document.querySelector('#enter_sign_up_otp_field');
var signup_verify_otp = document.querySelector('#signup_verify_otp');
var field_verify_otp = document.querySelector('#customer_sign_otp');
var resendOtpSignup = document.querySelector('#resend_otp_signup');
var otpTimer = document.querySelector('#otp_timer');

function startTimer(duration, display) {
    var timer = duration, minutes, seconds;
    var interval = setInterval(() => {
        minutes = Math.floor(timer / 60);
        seconds = timer % 60;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        display.textContent = `Resend OTP in ${minutes}:${seconds}`;
        
        if (--timer < 0) {
            clearInterval(interval);
            display.style.display = 'none';
            resendOtpSignup.style.display = 'inline';
        }
    }, 1000);
}

function sendOtpApiCall() {
    var mobileNumberSignup = mobileNumber.value.trim();
    var emailValue = email_id.value.trim();
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    var raw = JSON.stringify({
        "phoneNumber": mobileNumberSignup,
        "email": emailValue
    });
    
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };
    
    fetch("https://dermalogica-otp-9112e155e180.herokuapp.com/otplogin/lakmesalonshop/register/sendotp", requestOptions)
        .then(response => response.json())
        .then(result => { 
            console.log(result);
            if (result.success === true) {
                message.textContent = result.message;
                message.style.display = 'block';
                message.style.color = 'green';
                enterSignOtp.style.display = 'block';  
                signup_verify_otp.style.display = 'block';
                signgetOtpBtntn.style.display = 'none';
                otpTimer.style.display = 'block';
                resendOtpSignup.style.display = 'none';
                startTimer(300, otpTimer); 
                setTimeout(() => {
                    message.style.display = 'none';
                }, 3000);
            } else {
                message.textContent = result.message;
                message.style.display = 'block';
                message.style.color = 'red';
                signup_verify_otp.style.display = 'none';
                signgetOtpBtntn.style.display = 'block';
                setTimeout(() => {
                    message.style.display = 'none';
                }, 3000);
            }
        })
        .catch(error => { 
            console.log('error', error);
        });
}

  if(signgetOtpBtntn) {
signgetOtpBtntn.addEventListener('click', function () {
    sendOtpApiCall();
});
  }
if(resendOtpSignup) {
resendOtpSignup.addEventListener('click', function () {
    resendOtpSignup.style.display = 'none';
    otpTimer.style.display = 'block';
    startTimer(300, otpTimer);
    sendOtpApiCall();
});
}

// sign up verify otp start
  
  signup_verify_otp?.addEventListener('click', function (event) {
    var mobile_number_v = document.querySelector('#customer_sign_up_mobile_number').value.trim();
    var email_v = document.querySelector('#RegisterForm-email').value.trim();
    var first_name = document.querySelector('#RegisterForm-FirstName');
    var last_name = document.querySelector('#RegisterForm-LastName');
    var first_name_v = first_name.value.trim();
    var last_name_v = last_name.value.trim();
    var enterSignOtp_v = document.querySelector('#customer_sign_otp').value.trim();
  
    var marketingConsentCheckbox = document.querySelector('.customer_consent-section input[type="checkbox"]');
    var marketingConsent = marketingConsentCheckbox.checked; 
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      
      var raw = JSON.stringify({
        "mobileNumber": mobile_number_v,
        "email": email_v,
        "first_name": first_name_v,
        "last_name": last_name_v,
        "note": "",
        "otp": enterSignOtp_v,
        "accept_marketing": marketingConsent
      });
      
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      
      fetch("https://dermalogica-otp-9112e155e180.herokuapp.com/otplogin/lakmesalonshop/register/verifyotp", requestOptions)
    .then(response => response.json())
    .then(result => { 
      console.log(result);
      if (result.success === true) {
        window.location.href = result.url;
        mendatoryFieldMsg.textContent = result.message;
        mendatoryFieldMsg.style.display = "block";
        mendatoryFieldMsg.style.color = 'red';
      } else {
        mendatoryFieldMsg.textContent = result.message;
        mendatoryFieldMsg.style.display = "block";
        mendatoryFieldMsg.style.color = 'red';
      }
    })
    .catch(error => { 
      console.log('error', error);
    });

});
  
});

